import React from "react";
import ChatBot from "./components/ChatBot"

const App = () => {
  return (
    <div>
      <ChatBot />
    </div>
  );
};

export default App;

